<template>
  <div>
    <form @submit.prevent="update()" method="post" enctype="multipart/form-data">
      <b-row>
        <b-col sm="5" class="center-block">
          <b-row>
            <b-col sm="12">
              <b-alert show variant="primary">
                <b>La contraseña debe contener:</b>

                <li>Mínimo 8 caracteres.</li>
                <li>Letra mayuscula.</li>
                <li>Letra minúscula.</li>
                <li>Número.</li>
                <li>Carácter especial.</li>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" v-if="errores.length">
              <b-alert show variant="warning">
                <b>ADVERTENCIAS:</b>
                <li class="ml-2" v-for="(error, index) in errores" :key="index">{{ error }}</li>
              </b-alert>
            </b-col>
          </b-row>

          <b-card header="CAMBIAR CONTRASEÑA">
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <label for="txtContrasenaConfirmar">Contraseña anterior</label>
                  <b-form-input
                    type="password"
                    id="txtContrasenaConfirmar"
                    v-model="user.password_prev"
                    autocomplete="new-password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <label for="txtContrasena">Contraseña nueva</label>
                  <b-form-input
                    type="password"
                    id="txtContrasena"
                    v-model="user.password"
                    autocomplete="new-password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-2 mb-2">
              <b-col sm="4" class="center-block">
                <b-button type="submit" variant="success" class="btn-sm col-sm-12">Guardar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
export default {
  name: "userpassword",
  data: () => {
    return {
      token: localStorage.getItem("token"),
      user: { password: "", password_prev: "" },
      user_id: JSON.parse(localStorage.getItem("auth"))[0].id,
      errores: [],
    };
  },
  mounted() {},
  methods: {
    update() {
      if (!this.validateForm()) {
        hideLoader();
        return false;
      }
      showLoader();
      console.log(this.user);
      this.$http
        .put(
          `${this.$urlApi}users/updatepassword/${this.user_id}?token=${this.token}`,
          JSON.stringify(this.user),
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Contraseña actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR LA SESIÓN, PARA QUE INGRESE CON SU NUEVA CONTRASEÑA
              this.$http
                .post(`${this.$urlApi}auth/logout?token=${this.token}`, {
                  headers: { "Content-Type": "application/json" },
                })
                .then(function (response) {
                  localStorage.clear();
                  sessionStorage.clear();
                  location.href = `${location.origin}/#/login`;
                  location.reload();
                });
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    validateForm: function () {
      this.errores = [];
      // VALIDAR LAS CONTRASEÑA
      if (!validatePassword(this.user.password)) {
        this.errores.push(
          "La contraseña es debil, debe contener 8 caracteres, como: letra mayuscula, letra minúscula, número y carácter especial!"
        );
      }
      return this.errores.length === 0;
    },
  },
};
</script>
